import ReactPlayer from 'react-player';
import { twMerge } from 'tailwind-merge';
import { useBreakpoint } from 'utils/hooks/useBreakpoint';

type Props = {
  videoLink: string;
  forceSubtitles?: boolean;
  className?: string;
};

const VIDEO_HEIGHT_MOBILE = '185px';
const VIDEO_HEIGHT_DESKTOP = '455px';

export const VideoPlayer: React.FC<Props> = ({ videoLink, forceSubtitles = true, className }) => {
  const isMobile = useBreakpoint({ max: 'sm' });
  return (
    <div className={twMerge('mb-40 w-full', className)}>
      <ReactPlayer
        url={videoLink}
        width="100%"
        height={isMobile ? VIDEO_HEIGHT_MOBILE : VIDEO_HEIGHT_DESKTOP}
        config={{
          youtube: {
            playerVars: {
              /** @note(juan): this is the var that youtube expects to force subtitles
              https://www.makeuseof.com/tag/force-subtitles-embedded-youtube-video/ */
              cc_load_policy: forceSubtitles ? 1 : 0,
            },
          },
        }}
      />
    </div>
  );
};
